// ===============================  商品設定  ===============================
export enum ActionType {
  CREATE = 'create',
  EDIT = 'edit',
  COPY = 'copy',
  UNKNOWN = 'unknown',
}

// ===============================  商品設定  ===============================
export enum SelectPattern {
  AUTO = 'AUTO',
  MANUAL = 'MANUAL',
}

// ===============================  廣告期間  ===============================
export enum RunningPattern {
  UNLIMITED = 'UNLIMITED',
  LIMITED = 'LIMITED',
}

// ===============================  廣告預算  ===============================
export enum BudgetType {
  DAILY = 'DAILY',
  TOTAL = 'TOTAL',
}
